import { isInvalidString, isInvalidUserName, isInvalidEmailGreeting } from "src/validation/stringValidation";
import { FormValidator } from "../formValidator";
import { ValidationError, ValidationErrors } from "src/errors";
import { UpdateUserSettingsFormDataKey } from "src/types";

class UpdateUserSettingsFormValidator extends FormValidator {
  private static validateUserName(value: unknown): ValidationError<"name"> | undefined {
    return isInvalidUserName(value) ? new ValidationError("Enter a valid user name", "name") : undefined;
  }

  private static validateEmailGreeting(value: unknown): ValidationError<"emailGreeting"> | undefined {
    return isInvalidEmailGreeting(value)
      ? new ValidationError("Enter a valid email greeting", "emailGreeting")
      : undefined;
  }

  private static validatePurchaseOrderEmailBody(value: unknown): ValidationError<"purchaseOrderEmailBody"> | undefined {
    return isInvalidString(value, 2, 1500)
      ? new ValidationError("Enter a valid purchase order body", "purchaseOrderEmailBody")
      : undefined;
  }

  private static validateEmailValediction(value: unknown): ValidationError<"emailValediction"> | undefined {
    return isInvalidString(value, 2, 40)
      ? new ValidationError("Enter a valid email valediction", "emailValediction")
      : undefined;
  }

  private static readonly validationStrategies: Record<
    UpdateUserSettingsFormDataKey,
    (value: unknown) => ValidationError<UpdateUserSettingsFormDataKey> | undefined
  > = {
    name: UpdateUserSettingsFormValidator.validateUserName,
    emailGreeting: UpdateUserSettingsFormValidator.validateEmailGreeting,
    purchaseOrderEmailBody: UpdateUserSettingsFormValidator.validatePurchaseOrderEmailBody,
    emailValediction: UpdateUserSettingsFormValidator.validateEmailValediction
  };

  static validateUserFormData<T extends UpdateUserSettingsFormDataKey>(
    formData: Partial<Record<T, unknown>>
  ): ValidationErrors<T> {
    return super.validateFormData(
      formData,
      UpdateUserSettingsFormValidator.validationStrategies
    ) as ValidationErrors<T>;
  }
}

export { UpdateUserSettingsFormValidator };
